// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__LIgcY","icon":"tabs_icon__Y-dAm","Active-btn":"tabs_Active-btn__1b5Cb","overlay":"tabs_overlay__D7m+P","showTabs":"tabs_showTabs__o9BQo"};